import axios from "./_axios";
import { API } from "./apiEndPoints";
import { updateAccountCounts } from "@/utils/accountCountUtils";

//https://api.dev.exiqtive.com/redoc/#tag/common/operation/common_account_role_list
export const getListOfRoles = async (account_id, page_no, size) => {
  let result = await axios()({
    method: "get",
    url: `${API.ACCOUNTList}${account_id}/role/`,
    params: { page: page_no, size: size },
  });
  return result;
};
export const getListOfRolesV2 = (
  account_id,
  limit,
  offset,
  search,
  filters = {},
  ordering = null
) => {
  const params = {
    limit: limit,
    offset: offset,
    name: search,
  };

  // Add status filters (multiple values allowed)
  if (filters.status && filters.status.length > 0) {
    params.status = filters.status;
  }

  // Add coverage filters (single value)
  if (filters.no_masters) {
    params.no_masters = true;
  }
  if (filters.no_coaches) {
    params.no_coaches = true;
  }
  if (filters.no_professionals) {
    params.no_professionals = true;
  }

  // Add archived filter
  if (filters.archived !== undefined) {
    params.archived = filters.archived;
  }

  // Add positions filter
  if (filters.positions === "no") {
    params.positions = "no";
  }

  // Add responsibilities filter
  if (filters.responsibilities === "no") {
    params.responsibilities = "no";
  }

  // Add responsibilities filter
  // Add timeline filters
  if (filters.recently_activated) {
    params.recently_activated = true;
  }
  if (filters.recently_retired) {
    params.recently_retired = true;
  }
  if (filters.recently_deactivated) {
    params.recently_deactivated = true;
  }
  if (filters.recently_created) {
    params.recently_created = true;
  }
  if (ordering) {
    params.ordering = ordering;
  }
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/role/`,
    params: params,
    paramsSerializer: (params) => {
      const parts = [];
      Object.keys(params).forEach((key) => {
        const value = params[key];
        if (Array.isArray(value)) {
          value.forEach((v) => {
            parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(v)}`);
          });
        } else if (value !== undefined) {
          parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
      });
      return parts.join("&");
    },
  });
  return result;
};
export const getRolesAssignedToPosition = (account_id, positionId) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/role/?position=${positionId}`,
  });
  return result;
};
export const getRolesListAvailableForPosition = (
  account_id,
  positionId,
  limit,
  offset,
  search
) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/role/`,
    params: {
      attachable_to: positionId,
      limit: limit,
      offset: offset,
      name: search,
    },
  });
  return result;
};

// https://api.dev.exiqtive.com/redoc/#tag/common/operation/common_account_role_read
export const getRole = async (account_id, role_id) => {
  let result = await axios()({
    method: "get",
    url: `${API.ACCOUNTList}${account_id}/role/${role_id}`,
    params: {},
  });
  return result;
};
// https://api.dev.exiqtive.com/redoc/#tag/common/operation/common_account_role_create
export const addRole = (account_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/role/`,
    data: data,
  });
  return result;
};
// https://api.dev.exiqtive.com/redoc/#tag/common/operation/common_account_role_update
export const updateRole = (account_id, role_id, data) => {
  let result = axios()({
    method: "put",
    url: `${API.ACCOUNTList}${account_id}/role/${role_id}/`,
    data: data,
  });
  return result;
};
// PATCH method for partial updates to role
export const editRole = (account_id, role_id, data) => {
  let result = axios()({
    method: "patch",
    url: `${API.ACCOUNTList}${account_id}/role/${role_id}/`,
    data: data,
  });
  return result;
};
// https://api.dev.exiqtive.com/redoc/#tag/common/operation/common_account_attach_create
export const attachResponsibilityToRole = (account_id, roleId, data) => {
  const resId = data?.attachment_id;
  const payload = {
    role: roleId,
    responsibility: resId,
  };
  let result = axios()({
    method: "post",
    url: `${API.RESPONSIBILITY_V2}${account_id}/responsibility/${resId}/role-to-responsibility/`,
    data: payload,
  });
  return result;
};
export const updateActiveRole = async (account_id, role_id, data) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/role/${role_id}/activate/`,
    data: data,
  });
  await updateAccountCounts(account_id);
  return result;
};
// https://api.dev.exiqtive.com/redoc/#tag/common/operation/common_account_role_update
export const updateRetiredRole = async (account_id, role_id, data) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/role/${role_id}/retire/`,
    data: data,
  });
  await updateAccountCounts(account_id);
  return result;
};
export const updateArchiveRole = async (account_id, objType, orgId) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/${objType}/${orgId}/archive/`,
  });
  await updateAccountCounts(account_id);
  return result;
};
export const updateUnArchiveRole = async (account_id, objType, orgId) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/${objType}/${orgId}/unarchive/`,
  });
  await updateAccountCounts(account_id);
  return result;
};
// https://api.dev.exiqtive.com/redoc/#tag/common/operation/common_account_role_delete
export const deleteReadinessRole = (account_id, role_id) => {
  let result = axios()({
    method: "delete",
    url: `${API.ACCOUNTList}${account_id}/role/${role_id}/`,
  });
  return result;
};
export const deleteReadinessRoleWithResponsibilities = (
  account_id,
  role_id,
  data
) => {
  let result = axios()({
    method: "delete",
    url: `${API.ACCOUNTList}${account_id}/role/${role_id}/?delete_draft_responsibilities=${data.delete_draft_responsibilities}`,
  });
  return result;
};
// https://api.dev.exiqtive.com/api/common/account/{account_id}/{type}/{obj_id}/de-activate/
export const updateDeActiveRole = async (account_id, role_id, data) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/role/${role_id}/de-activate/`,
    data: data,
  });
  await updateAccountCounts(account_id);
  return result;
};
// https://api.dev.exiqtive.com/api/common/account/{account_id}/{type}/{obj_id}/re-activate/
export const updateReActiveRole = async (account_id, role_id, data) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/role/${role_id}/re-activate/`,
    data: data,
  });
  await updateAccountCounts(account_id);
  return result;
};
//https://api.dev.exiqtive.com/api/common/account/{account_id}/position/{id}/
export const getPositionId = (account_id, pos_id) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/position/${pos_id}/`,
  });
  return result;
};
//https://api.dev.exiqtive.com/redoc/#tag/proficiency/operation/Get%20role%20chatter
//https://api.dev.exiqtive.com/api/proficiency/account/{account_id}/role/{role_id}/chatter/
export const getRoleChatter = (account_id, role_id, page = 1) => {
  let result = axios()({
    method: "get",
    url: `${API.RESPONSIBILITY}${account_id}/role/${role_id}/chatter/`,
    params: { page: page },
  });
  return result;
};

export const getRoleId = (account_id, role_id) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNTList}${account_id}/role/${role_id}/`,
  });
  return result;
};

export const detachAttachments = (account_id, role_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/responsibility/${role_id}/detach/`,
    data: data,
  });
  return result;
};

export const detachRoleAttachment = (account_id, obj_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/role/${obj_id}/detach/`,
    data: data,
  });
  return result;
};

export const detachOrgObject = (account_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/${data.childType}/${data.childId}/detach/`,
    data: data.parentData,
  });
  return result;
};

export const updateNameRole = (account_id, role_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/role/${role_id}/rename/`,
    data: data,
  });
  return result;
};

export const attachResponsibilitiesToRoleBulk = (account_id, role_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.PROFICIENCY_V1}${account_id}/role/${role_id}/responsibility-to-role-bulk/`,
    data: data,
  });
  return result;
};

export const getRoleAssignment = (
  account_id,
  employee_id,
  position_assignment_id,
  status = null
) => {
  let params = `employee=${employee_id}&position_assignment=${position_assignment_id}`;
  if (status) {
    params += `&status=${status}`;
  }

  let result = axios()({
    method: "get",
    url: `${API.PROFICIENCY_V2}${account_id}/role-assignment/?${params}`,
  });
  return result;
};

export const getRoleAttachmentsFromResponsibilities = (account_id, role_id) => {
  let result = axios()({
    method: "get",
    url: `${API.RESPONSIBILITY_V2}${account_id}/responsibility/`,
    params: { role: role_id, limit: 50 },
  });
  return result;
};

export const getRoleAttachmentsFromPositions = (account_id, role_id) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/position/`,
    params: { role: role_id, limit: 50 },
  });
  return result;
};
export const getListOfRolesAttachedToPosition = (
  account_id,
  limit,
  offset,
  search,
  filters = {},
  positionId
) => {
  const params = {
    limit: limit,
    offset: offset,
    name: search,
    position: positionId,
  };

  // Add status filters (multiple values allowed)
  if (filters.status && filters.status.length > 0) {
    params.status = filters.status;
  }

  // Add coverage filters (single value)
  if (filters.no_masters) {
    params.no_masters = true;
  }
  if (filters.no_coaches) {
    params.no_coaches = true;
  }
  if (filters.no_professionals) {
    params.no_professionals = true;
  }

  // Add archived filter
  if (filters.archived !== undefined) {
    params.archived = filters.archived;
  }

  // Add positions filter
  if (filters.positions === "no") {
    params.positions = "no";
  }

  // Add responsibilities filter
  if (filters.responsibilities === "no") {
    params.responsibilities = "no";
  }

  // Add responsibilities filter
  // Add timeline filters
  if (filters.recently_activated) {
    params.recently_activated = true;
  }
  if (filters.recently_retired) {
    params.recently_retired = true;
  }
  if (filters.recently_deactivated) {
    params.recently_deactivated = true;
  }
  if (filters.recently_created) {
    params.recently_created = true;
  }

  let result = axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/role/`,
    params: params,
    paramsSerializer: (params) => {
      const parts = [];
      Object.keys(params).forEach((key) => {
        const value = params[key];
        if (Array.isArray(value)) {
          value.forEach((v) => {
            parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(v)}`);
          });
        } else if (value !== undefined) {
          parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
      });
      return parts.join("&");
    },
  });
  return result;
};
export const getListOfResponsibilitiesAttachedToRole = (
  account_id,
  limit,
  offset,
  search,
  filters = {},
  roleId,
  include_badge_holders = false
) => {
  const params = {
    limit: limit,
    offset: offset,
    name: search,
    role: roleId,
    include_badge_holders: include_badge_holders,
  };

  // Add status filters (multiple values allowed)
  if (filters.status && filters.status.length > 0) {
    params.status = filters.status;
  }

  // Add coverage filters (single value)
  if (filters.no_masters) {
    params.no_masters = true;
  }
  if (filters.no_coaches) {
    params.no_coaches = true;
  }
  if (filters.no_professionals) {
    params.no_professionals = true;
  }

  // Add archived filter
  if (filters.archived !== undefined) {
    params.archived = filters.archived;
  }

  // Add positions filter
  if (filters.positions === "no") {
    params.positions = "no";
  }

  // Add responsibilities filter
  if (filters.responsibilities === "no") {
    params.responsibilities = "no";
  }

  // Add responsibilities filter
  // Add timeline filters
  if (filters.recently_activated) {
    params.recently_activated = true;
  }
  if (filters.recently_retired) {
    params.recently_retired = true;
  }
  if (filters.recently_deactivated) {
    params.recently_deactivated = true;
  }
  if (filters.recently_created) {
    params.recently_created = true;
  }

  let result = axios()({
    method: "get",
    url: `${API.RESPONSIBILITY_V2}${account_id}/responsibility/`,
    params: params,
    paramsSerializer: (params) => {
      const parts = [];
      Object.keys(params).forEach((key) => {
        const value = params[key];
        if (Array.isArray(value)) {
          value.forEach((v) => {
            parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(v)}`);
          });
        } else if (value !== undefined) {
          parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
      });
      return parts.join("&");
    },
  });
  return result;
};
